import * as api from '../../api/equityFinder/master';
import * as propertyApi from '../../api/equityFinder/property';
import { makeApiActionCreatorV3 } from '../utils';

export const MASTER_FETCH_START = 'MASTER/MASTER_FETCH_START';
export const MASTER_FETCH_SUCCESS = 'MASTER/MASTER_FETCH_SUCCESS';
export const MASTER_FETCH_ERROR = 'MASTER/MASTER_FETCH_ERROR';

export const MASTER_REMOVE_START = 'MASTER/MASTER_REMOVE_START';
export const MASTER_REMOVE_SUCCESS = 'MASTER/MASTER_REMOVE_SUCCESS';
export const MASTER_REMOVE_ERROR = 'MASTER/MASTER_REMOVE_ERROR';

export const MASTER_ADD_START = 'MASTER/MASTER_ADD_START';
export const MASTER_ADD_SUCCESS = 'MASTER/MASTER_ADD_SUCCESS';
export const MASTER_ADD_ERROR = 'MASTER/MASTER_ADD_ERROR';

export const MASTER_COPY_START = 'MASTER/MASTER_COPY_START';
export const MASTER_COPY_SUCCESS = 'MASTER/MASTER_COPY_SUCCESS';
export const MASTER_COPY_ERROR = 'MASTER/MASTER_COPY_ERROR';

export const MASTER_COMP_PROPERTY_SEARCH_START =
  'MASTER/MASTER_COMP_PROPERTY_SEARCH_START';
export const MASTER_COMP_PROPERTY_SEARCH_SUCCESS =
  'MASTER/MASTER_COMP_PROPERTY_SEARCH_SUCCESS';
export const MASTER_COMP_PROPERTY_SEARCH_ERROR =
  'MASTER/MASTER_COMP_PROPERTY_SEARCH_ERROR';

export const MASTER_COMP_PROPERTY_SELECT_START =
  'MASTER/MASTER_COMP_PROPERTY_SELECT_START';
export const MASTER_COMP_PROPERTY_SELECT_SUCCESS =
  'MASTER/MASTER_COMP_PROPERTY_SELECT_SUCCESS';
export const MASTER_COMP_PROPERTY_SELECT_ERROR =
  'MASTER/MASTER_COMP_PROPERTY_SELECT_ERROR';

export const MASTER_COMP_PROPERTY_CHANGE_CURRENT_PAGE =
  'MASTER/MASTER_COMP_PROPERTY_CHANGE_CURRENT_PAGE';
export const MASTER_COMP_PROPERTY_CHANGE_SORT_MODEL =
  'MASTER/MASTER_COMP_PROPERTY_CHANGE_SORT_MODEL';
export const MASTER_COMP_PROPERTY_CHANGE_PAGE_SIZE =
  'MASTER/MASTER_COMP_PROPERTY_CHANGE_PAGE_SIZE';
export const MASTER_COMP_PROPERTY_SET_SEARCH_RULE =
  'MASTER/MASTER_COMP_PROPERTY_SET_SEARCH_RULE';
export const MASTER_COMP_PROPERTY_REMOVE_SEARCH_RULE =
  'MASTER/MASTER_COMP_PROPERTY_REMOVE_SEARCH_RULE';
export const MASTER_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE =
  'MASTER/MASTER_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE';

export const MASTER_COMP_SELECT_PROPERTY = 'MASTER/MASTER_COMP_SELECT_PROPERTY';

export const fetchMasterList = makeApiActionCreatorV3(
  api.fetchMasterList,
  MASTER_FETCH_START,
  MASTER_FETCH_SUCCESS,
  MASTER_FETCH_ERROR,
);
export const copyMaster = makeApiActionCreatorV3(
  api.copyMaster,
  MASTER_COPY_START,
  MASTER_COPY_SUCCESS,
  MASTER_COPY_ERROR,
);
export const addMaster = makeApiActionCreatorV3(
  api.addMaster,
  MASTER_ADD_START,
  MASTER_ADD_SUCCESS,
  MASTER_ADD_ERROR,
);
export const removeMaster = makeApiActionCreatorV3(
  api.removeMaster,
  MASTER_REMOVE_START,
  MASTER_REMOVE_SUCCESS,
  MASTER_REMOVE_ERROR,
);
export const searchMasterCompProperty = makeApiActionCreatorV3(
  propertyApi.searchProperty,
  MASTER_COMP_PROPERTY_SEARCH_START,
  MASTER_COMP_PROPERTY_SEARCH_SUCCESS,
  MASTER_COMP_PROPERTY_SEARCH_ERROR,
);
export const masterCompPropertiesSelect = makeApiActionCreatorV3(
  api.masterCompPropertiesSelect,
  MASTER_COMP_PROPERTY_SELECT_START,
  MASTER_COMP_PROPERTY_SELECT_SUCCESS,
  MASTER_COMP_PROPERTY_SELECT_ERROR,
);

export function changeMasterCompCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: MASTER_COMP_PROPERTY_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeMasterCompSortModel(model) {
  return async dispatch => {
    dispatch({ type: MASTER_COMP_PROPERTY_CHANGE_SORT_MODEL, data: model });
  };
}

export function changeMasterCompPageSize(page) {
  return async dispatch => {
    dispatch({ type: MASTER_COMP_PROPERTY_CHANGE_PAGE_SIZE, data: page });
  };
}

export function setMasterCompRule(ruleName, ruleValue) {
  return async dispatch => {
    dispatch({
      type: MASTER_COMP_PROPERTY_SET_SEARCH_RULE,
      data: { ruleName, ruleValue },
    });
  };
}

export function removeMasterCompRule(ruleName) {
  return async dispatch => {
    dispatch({
      type: MASTER_COMP_PROPERTY_REMOVE_SEARCH_RULE,
      data: { ruleName },
    });
  };
}

export function removeAllMasterCompRule() {
  return async dispatch => {
    dispatch({ type: MASTER_COMP_PROPERTY_REMOVE_ALL_SEARCH_RULE });
  };
}

export function selectMasterCompProperty(propIds) {
  return async dispatch => {
    dispatch({ type: MASTER_COMP_SELECT_PROPERTY, data: propIds });
  };
}
